
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9a228e22&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DemoTop.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DemoTop.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-9a228e22!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DemoTop.vue"),
  /* scopeId */
  "data-v-9a228e22",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/DemoTop.vue
// module id = 607
// module chunks = 0